import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

import { NHATestDirective } from '../../directives/test/test.directive';

export interface ISnackbarMessage {
	message: string;
	isHtml: boolean;
	action: string;
}

@Component({
	selector: 'nha-snack-bar',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['snack-bar.component.scss'],
	templateUrl: 'snack-bar.component.html',
	imports: [NHATestDirective, MatSnackBarLabel, MatSnackBarActions, MatButtonModule, MatSnackBarAction]
})
export class NHASnackbarComponent {
	snackBarRef = inject<MatSnackBarRef<NHASnackbarComponent>>(MatSnackBarRef);

	data: ISnackbarMessage;

	constructor() {
		const data = inject<ISnackbarMessage>(MAT_SNACK_BAR_DATA);

		this.data = data;
	}

	action(): void {
		this.snackBarRef.dismissWithAction();
	}

	get hasAction(): boolean {
		return !!this.data.action;
	}
}
